import React, { useEffect, useState } from 'react';
import { PNG } from 'pngjs/browser';
import styled from 'styled-components';

import { Image } from '../../Typhography';
import { ImageProps } from '../../Typhography/Image';

const ColoringGridImageStyled = styled(Image)`
  image-rendering: pixelated;
`;
const grayedImageSrc = async (imageSrc: string) => {
  const response = await fetch(imageSrc);
  const data = await response.blob();
  const file = new File([data], 'image.png', { type: 'image/png' });
  const arrayBuffer = await file.arrayBuffer();
  const buffer = Buffer.from(arrayBuffer);
  const png = PNG.sync.read(buffer);

  for (let y = 0; y < png.height; y++) {
    for (let x = 0; x < png.width; x++) {
      const idx = (png.width * y + x) << 2;
      let gray = 0.3 * png.data[idx] + 0.6 * png.data[idx + 1] + 0.11 * png.data[idx + 2] + 25;
      if (gray > 255) {
        gray = 255;
      }
      png.data[idx] = gray;
      png.data[idx + 1] = gray;
      png.data[idx + 2] = gray;
    }
  }

  const outputBuffer = PNG.sync.write(png);

  return `data:image/jpeg;base64, ${outputBuffer.toString('base64')}`;
};

export default function ColoringGridImage(
  props: ImageProps & React.ImgHTMLAttributes<HTMLImageElement>,
) {
  const [imagePreview, setImagePreview] = useState(props.src);
  const [grayed, setGrayed] = useState<string>('');

  useEffect(() => {
    if (props.src) {
      setImagePreview(props.src);
      setGrayed('');
    }
  }, [props.src]);

  return (
    <ColoringGridImageStyled
      {...props}
      onMouseEnter={async () => {
        if (grayed) {
          setImagePreview(grayed);
          return;
        }

        const grey = await grayedImageSrc(props.src || '');
        setGrayed(grey);
        setImagePreview(grey);
      }}
      onMouseLeave={() => {
        setImagePreview(props.src);
      }}
      src={imagePreview}
    />
  );
}
